import React from 'react';
import { Link } from 'react-router-dom';

function AccountDeleted() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Account Deleted
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Your account has been successfully deleted.
          </p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="rounded-full bg-green-100 h-24 w-24 flex items-center justify-center mx-auto">
            <svg className="h-12 w-12 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p className="mt-4 text-gray-700">
            We've removed all your data including:
          </p>
          <ul className="mt-2 text-gray-600 text-left list-disc pl-5 space-y-1">
            <li>QR codes and scan data</li>
            <li>Shortened links and click data</li>
            <li>Account and subscription information</li>
            <li>User profile details</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Thank you for using our service. We're sorry to see you go.
          </p>
          <div className="mt-6">
            <Link
              to="/"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Return to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDeleted;